// Tesis türü (çoklu) yardımcıları — tüm modüller ortak kullanır. Saklama: kod listesi ["yurt","spor_salonu"].
export const TESIS_TURU_OPTIONS = [
  { value: 'sosyal_tesis', label: 'Sosyal Tesis' },
  { value: 'idari_bina', label: 'İdari Bina' },
  { value: 'kantin_kafe', label: 'Kantin/Kafe' },
  { value: 'stad', label: 'Stad' },
  { value: 'lojman', label: 'Lojman' },
  { value: 'spor_tesisi', label: 'Spor Tesisi' },
  { value: 'kamp_egitim', label: 'Kamp Eğitim' },
  { value: 'genclik_merkezi', label: 'Gençlik Merkezi' },
  { value: 'spor_salonu', label: 'Spor Salonu' },
  { value: 'yuzme_havuzu', label: 'Yüzme Havuzu' },
  { value: 'stadyum', label: 'Stadyum' },
  { value: 'yurt', label: 'Yurt' },
  { value: 'il_mudurlugu', label: 'İl Müdürlüğü' },
  { value: 'diger', label: 'Diğer' },
];

export const TESIS_TURU_LABELS = Object.fromEntries(TESIS_TURU_OPTIONS.map(o => [o.value, o.label]));
const LEGACY = { spor: 'spor_tesisi', spor_kompleksi: 'spor_tesisi', spor_tesis: 'spor_tesisi', kantin: 'kantin_kafe', kafe: 'kantin_kafe' };

// 'KAMP EĞİTİM' / 'kamp_egitim' / 'Kamp Eğitim' → 'kamp_egitim'; 'SPOR' → 'spor_tesisi'
export const normalizeTesisTuru = (v) => {
  if (v === null || v === undefined || v === '') return '';
  const code = String(v).trim().toLocaleLowerCase('tr')
    .replace(/ı/g, 'i').replace(/ş/g, 's').replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ö/g, 'o').replace(/ç/g, 'c')
    .replace(/\s+/g, '_');
  return LEGACY[code] || code;
};

// str | array | null → benzersiz kod listesi
export const tesisTuruList = (v) => {
  const raw = Array.isArray(v) ? v : (v ? [v] : []);
  return [...new Set(raw.map(normalizeTesisTuru).filter(Boolean))];
};

const prettify = (code) => String(code || '').replace(/_/g, ' ').toLocaleLowerCase('tr').replace(/(^|\s)\S/g, (c) => c.toLocaleUpperCase('tr'));

export const tesisTuruLabel = (code) => TESIS_TURU_LABELS[normalizeTesisTuru(code)] || prettify(code);

// Kayıttaki tüm türler → "Yurt, Spor Salonu" ('' boşsa)
export const tesisTuruText = (v, sep = ', ') => tesisTuruList(v).map(tesisTuruLabel).join(sep);

// Filtre: seçilen türlerden herhangi biri kayıtta var mı? (seçim boşsa hepsi geçer; 'bos' → türü olmayanlar)
export const tesisTuruMatches = (v, selected) => {
  const wanted = tesisTuruList(selected);
  if (wanted.length === 0) return true;
  const codes = tesisTuruList(v);
  if (wanted.includes('bos') && codes.length === 0) return true;
  return codes.some(c => wanted.includes(c));
};

// Kayıtlardaki türlerden filtre seçenekleri: [{v, l}]
export const tesisTuruOptionsFrom = (records, key = 'tesis_turu') => {
  const codes = [...new Set(records.flatMap(r => tesisTuruList(r?.[key])))];
  return codes.sort((a, b) => tesisTuruLabel(a).localeCompare(tesisTuruLabel(b), 'tr')).map(c => ({ v: c, l: tesisTuruLabel(c) }));
};
